import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints, vars } from "../../../styles";

// Preserves 3rem right padding for the dropdown arrow
const arrowWidth = "3rem";

const fixtureBase = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: vars.space.xs,
  padding: `${vars.space.m} ${arrowWidth} ${vars.space.m} ${vars.space.m}`,
  textAlign: "center",
  color: vars.colors.onSurface,
  fontFamily: vars.fonts.bold,
  containerType: "inline-size",
  "@container": {
    [`(min-width: 610px)`]: {
      flexDirection: "row",
    },
  },
});

// placeholder styles
export const fixtureStyles = styleVariants({
  default: [fixtureBase],
  isStarted: [fixtureBase],
});

export const teams = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: vars.space.xs,
});

export const team = style({
  display: "flex",
  flex: 1,
  alignItems: "center",
  justifyContent: "flex-start",
  gap: vars.space.xs,
  minWidth: 0,
});

export const teamH = style([
  team,
  {
    justifyContent: "flex-end",
    textAlign: "end",
  },
]);

export const teamName = style({
  textWrap: "nowrap",
  fontSize: vars.fontSizes.body.s,
});

export const fixtureBadge = style({
  display: "inline-block",
  width: "2.4rem",
  height: "2.4rem",
});

const fixtureScoreBase = style({
  display: "flex",
  borderRadius: vars.radii.xs,
  padding: `${vars.space["2xs"]} ${vars.space.xs}`,
  color: vars.colors.onPrimary,
  fontSize: vars.fontSizes.body.l,
});

// placeholder styles
export const fixtureScore = styleVariants({
  finished: [
    fixtureScoreBase,
    {
      background: vars.colors.primaryFixed,
      color: vars.colors.onPrimaryFixed,
    },
  ],
  notFinished: [
    fixtureScoreBase,
    {
      background: vars.colors.liveMatchGradient,
      color: vars.colors.onPrimaryFixed,
      selectors: {
        '[dir="rtl"] &': {
          background: vars.colors.liveMatchGradientRtl,
        },
      },
    },
  ],
});

export const broadcaster = style({
  "@container": {
    [`(min-width: ${breakpoints[1]})`]: {
      position: "absolute",
      insetInlineEnd: arrowWidth,
    },
  },
});

export const broadcasterList = style({
  display: "flex",
  justifyContent: "center",
  margin: 0,
  paddingInlineStart: 0,
  listStyleType: "none",
});

export const broadcasterItem = style({
  display: "flex",
  selectors: {
    "&:not(:last-child)": {
      marginInlineEnd: vars.space.xs,
      borderInlineEnd: vars.borders.outline,
      paddingInlineEnd: vars.space.xs,
    },
  },
});

export const multipleBroadcastersButton = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space["2xs"],
  border: "none",
  borderRadius: vars.radii.xs,
  backgroundColor: vars.colors.primary,
  cursor: "pointer",
  padding: `${vars.space["2xs"]} ${vars.space.xs}`,
  height: "2.6rem",
  color: vars.colors.onPrimary,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.xs,
});

export const videoCamera = style({
  width: 10,
  height: 10,
  color: vars.colors.onPrimary,
});

export const buttonText = style({
  fontSize: vars.fontSizes.body.xs,
});

export const matchCard = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  width: "100%",
});

export const matchTimeIndicator = style({
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.xs,
  "@container": {
    [`(min-width: 610px)`]: {
      position: "absolute",
      top: "50%",
      insetInlineStart: "1.6rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      transform: "translateY(-50%)",
    },
  },
});

export const liveContainer = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: vars.space["2xs"],
});

export const fixtureDisclosureButton = style({
  position: "absolute",
  top: "35%",
  insetInlineEnd: 0,
});

export const chevronDownIcon = style({
  transformOrigin: "center",
  transition: "transform 0.2s",
  selectors: {
    '[data-expanded="true"] &': {
      transform: "rotate(-180deg)",
    },
  },
});
